module.exports = __webpack_public_path__ + "assets/images/chrome.924ba0c974756aadc246be71343db89a.png";